import { render, staticRenderFns } from "./ComplaintCategoryManage.vue?vue&type=template&id=71e44184&"
import script from "./ComplaintCategoryManage.vue?vue&type=script&lang=js&"
export * from "./ComplaintCategoryManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports